import ModifyingCacheCDNBehavior from "../../../../src/courses/partials/responsible-development/modifying-cache-cdn-behavior.mdx";
import * as React from 'react';
export default {
  ModifyingCacheCDNBehavior,
  React
};